const UNCATEGORIZED_CATEGORY_CODE = "NONE";

module.exports = UNCATEGORIZED_CATEGORY_CODE;
